import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { MailPersonIcon } from "modules/icons";
import { useOverlay } from "modules/providers/overlay-provider";

const AddExternalEmailUsersInfoModal = () => {
  const { closeModal } = useOverlay();

  return (
    <Modal isOpen onClose={closeModal} size="xs" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack textAlign="center" spacing={4}>
            <MailPersonIcon boxSize={54} />
            <Text fontSize={16} fontWeight={700}>
              Contacts Outside Organization
            </Text>
            <Text fontSize={13}>
              Users outside of the organization can be added to conversations in
              Synco by email.
            </Text>
            <Text fontSize={13}>
              Once added, they will be able to view all messages and files in
              the conversation and post messages to this conversation via email.
            </Text>
            <Text fontSize={13}>
              Note, outside contacts cannot view reactions to messages in the
              emails.
            </Text>
            <HStack>
              <Button height={8} px={10} onClick={closeModal}>
                Got it!
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(AddExternalEmailUsersInfoModal);
